import React, { Component } from "react";

export default class Timer extends Component {
  state = { time: {}, seconds: this.props.seconds };
  timer = 0;
  _Mounted = true;

  componentDidMount = () => {
    if (this._Mounted) {
      let timeLeftVar = this.secondsToTime(this.state.seconds);
      this.setState({ time: timeLeftVar });
      this.startTimer();
    }
  };

  componentWillUnmount = () => {
    this._Mounted = false;
  };

  secondsToTime = (secs) => {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  };

  startTimer = () => {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
      this.props.getTimmerProgress(this.state.seconds);
    }
  };

  countDown = () => {
    if (this._Mounted) {
      // Remove one second, set state so a re-render happens.
      let seconds = this.state.seconds - 1;
      this.setState({
        time: this.secondsToTime(seconds),
        seconds: seconds,
      });
      try {
        this.props.getTimmerProgress(seconds);
      } catch {}
      // Check if we're at zero.
      if (seconds === 0) {
        clearInterval(this.timer);
      }
    }
  };

  render() {
    if (
      this.state.time.s === 0 &&
      this.state.time.m === 0 &&
      this.state.time.h === 0
    ) {
      return null;
    }
    return (
      <label style={{ margin: "0" }}>
        {this.props.frontText}{" "}
        {this.state.time.m ? `${this.state.time.m}m ` : null}
        {this.state.time.s ? `${this.state.time.s}s ` : null}{" "}
        {this.props.endText}
      </label>
    );
  }
}
